import { apiPlataforma } from "../repositories/api.plataforma";

export interface AuditoriaUsuario {
  id_usuarios: number;
  nome: string | null;
  email: string;
  ativo: boolean;
  administrador: boolean;
  tipo: string | null;
  projetos?: number;
  ultimo_acesso?: string | null;
  ultimo_ip?: string | null;
}
export interface AuditoriaUsuariosParams {
  limit: number;
  offset: number;
  coluna: string;
  filtro: string;
  status: "todos" | "ativos" | "inativos";
  perfil: "todos" | "administradores" | "demais";
  orderBy: string;
  direction: "asc" | "desc";
}
export interface AuditoriaUsuariosResumo {
  totalRecords: number;
  ativos: number;
  inativos: number;
  administradores: number;
}
export interface AuditoriaPagina<T> {
  data: T[];
  limit: number;
  offset: number;
  hasMore: boolean;
}
export type AuditoriaRecurso = "projetos" | "camadas" | "acessos";

export async function listarAuditoriaUsuarios(params: AuditoriaUsuariosParams, signal?: AbortSignal) {
  const { data } = await apiPlataforma.get<AuditoriaPagina<AuditoriaUsuario>>("/auditoria/usuarios", {
    params,
    signal,
  });
  return data;
}
export async function resumirAuditoriaUsuarios(params: AuditoriaUsuariosParams, signal?: AbortSignal) {
  const { coluna, filtro, status, perfil } = params;
  const { data } = await apiPlataforma.get<AuditoriaUsuariosResumo>("/auditoria/usuarios/resumo", {
    params: { coluna, filtro, status, perfil },
    signal,
  });
  return data;
}
export async function obterAuditoriaUsuario(id: number, signal?: AbortSignal) {
  const { data } = await apiPlataforma.get<AuditoriaUsuario>(`/auditoria/usuarios/${id}`, { signal });
  return data;
}
export async function listarAuditoriaUsuarioRecurso(
  id: number,
  recurso: AuditoriaRecurso,
  offset: number,
  signal?: AbortSignal,
) {
  const { data } = await apiPlataforma.get<AuditoriaPagina<Record<string, string | number | boolean | null>>>(
    `/auditoria/usuarios/${id}/${recurso}`,
    { params: { limit: 10, offset }, signal },
  );
  return data;
}
